var $931fd402ea71f56a$exports = {};
$931fd402ea71f56a$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}irite za detalje`
};


export {$931fd402ea71f56a$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
